<template>
  <div>
    <ul class="detail-title">
      <li>{{$t('detail.用户名')}}</li>
      <li>{{$t('detail.内容')}}</li>
      <li>{{$t('detail.提交时间')}}</li>
    </ul>
    <ul class="detail-table scrollbar">
      <li v-for="(item, index) in lists" :key="index" class="detail-list">
        <span>{{ item.name }}</span>
        <span>{{ item.answer }}</span>
        <span>{{ item.submitTime }}</span>
      </li>
      <li v-if="pageCount === 0 || lists.length == 0" class="no-detail">
        <img :src="noDetail" width="192px" />
      </li>
    </ul>
    <el-pagination
      :hide-on-single-page="true"
      :total="pageCount"
      :current-page.sync="currentPage"
      @current-change="changePage"
      layout="prev, pager, next"
    >
    </el-pagination>
  </div>
</template>
<script>
import { getPaperDetail } from "@/api/liveRequest/questionnaireApi";
import noDetail from "@/assets/images/blank/blank.png";
export default {
  data() {
    return {
      noDetail,
      lists: [],
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      currentPage: 1,
    };
  },
  props: {
    confId: {
      type: String,
      default: "",
    },
    option: {
      type: String,
      default: "",
    },
    questionNum: {
      type: Number,
      default: -1,
    },
    type: {
      type: String,
      default: "",
    },
  },
  // watch: {
  //   option: {
  //     immediate: true,
  //     handler() {
  //       this.detail();
  //     },
  //   },
  // },
  mounted() {
    this.detail();
  },
  methods: {
    detail() {
      getPaperDetail(
        {
          confPaperId: this.confId,
          option: this.type === this.$t('detail.问答') ? "" : this.option,
          questionNum: this.questionNum,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
        this.$store.getters.liveToken
      ).then((res) => {
        console.log(res);
        let resData = res.data;
        if (res.code === 200) {
          this.pageCount = resData.pageCount;
          this.lists = resData.list;
        }
      });
    },
    changePage(current) {
      this.pageNum = current;
      this.detail();
    },
  },
};
</script>
<style lang="scss">
.detail-title {
  display: flex;
  justify-content: space-around;
  height: 30px;
  align-items: center;
  background: $purple6-color;
  color: $grey3-color;
  li {
    width: 33.33%;
    text-align: left;
    padding-left: 30px;
  }
  //border-radius: 2px;
}
.detail-table {
  height: 380px;
  overflow-y: auto;
}
.detail-list {
  display: flex;
  justify-content: space-around;
  min-height: 30px;
  align-items: center;
  color: #fff;
  border-bottom: 1px solid #3a4059;
  padding: 10px 0;
  span {
    width: 33.33%;
    text-align: left;
    padding-left: 30px;
  }
}
.no-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 70px;
}
</style>
